import React from 'react';
import { useSelector } from 'react-redux';
import EquipmentTemplate from '../../components/equiqtemplate/EquipmentTemplate';
import MechImg1 from '../../assest/Electronics-1.jpeg';
import MechImg2 from '../../assest/Mech.jpeg';
import MechImg3 from '../../assest/Mech-3.png';

const mechanicalTechniciansList = [
  {
    name: "HVAC Technician",
    image: MechImg1,
    specs: "Installation and repair of heating, ventilation, and AC systems.",
    description: "Experts in maintaining comfortable environments through efficient climate control systems.",
  },
  {
    name: "Automotive Technician",
    image: MechImg2,
    specs: "Vehicle diagnostics and repairs.",
    description: "Specialized in detecting and fixing issues in a wide range of vehicles and machinery.",
  },
  {
    name: "Manufacturing Technician",
    image: MechImg3,
    specs: "Support for factory machinery and production lines.",
    description: "Focused on assembling, maintaining, and troubleshooting equipment used in production.",
  },
];

const translations = {
  gb: {
    heading: "Mechanical Technician Services",
    introText: "Hire certified mechanical technicians for precision repairs and efficient system maintenance.",
    categoriesTitle: "Available Technicians",
    featuredTitle: "Top Mechanical Technicians",
    featuredDescription: "Professionals ready to support industrial, automotive, and HVAC systems.",
  },
  sa: {
    heading: "خدمات الفنيين الميكانيكيين",
    introText: "استعن بفنيين ميكانيكيين معتمدين لإصلاحات دقيقة وصيانة فعالة للأنظمة.",
    categoriesTitle: "الفنيون المتاحون",
    featuredTitle: "أفضل الفنيين الميكانيكيين",
    featuredDescription: "محترفون جاهزون لدعم الأنظمة الصناعية والسيارات والتكييف.",
  },
};

const MechanicalTechnicians = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  return (
    <EquipmentTemplate
      content={t}
      equipmentList={mechanicalTechniciansList}
      language={language}
    />
  );
};

export default MechanicalTechnicians;
